// Generated by `python3 pfma/scripts/generate_pages_data.py`. Do not edit manually.
import type { Collection, DocumentPreview, FilterOptions } from "./types";

export const collections: Collection[] = [
  {
    "id": "PFMA legislation",
    "name": "PFMA legislation",
    "description": "The PFMA, amendments, commencement notices, and primary legislative sources.",
    "count": 4,
    "accent": "green"
  },
  {
    "id": "Regulations",
    "name": "Regulations",
    "description": "Treasury Regulations, gazettes, and regulatory frameworks issued under the PFMA.",
    "count": 18,
    "accent": "gold"
  },
  {
    "id": "Practice notes",
    "name": "Practice notes",
    "description": "National Treasury practice notes and instructions for public-finance administration.",
    "count": 70,
    "accent": "red"
  },
  {
    "id": "Circulars",
    "name": "Circulars",
    "description": "Operational circulars, system notices, reporting changes, and implementation updates.",
    "count": 21,
    "accent": "blue"
  },
  {
    "id": "Guidelines",
    "name": "Guidelines",
    "description": "Implementation guides, year-end guidance, templates, and supporting reference material.",
    "count": 28,
    "accent": "green"
  },
  {
    "id": "Delegations",
    "name": "Delegations",
    "description": "Delegations of authority and responsibility under the PFMA and Treasury Regulations.",
    "count": 3,
    "accent": "gold"
  },
  {
    "id": "Delays and exemptions",
    "name": "Delays and exemptions",
    "description": "Approved exemptions, delays, commencement notices, and related gazettes.",
    "count": 13,
    "accent": "red"
  },
  {
    "id": "Public entities",
    "name": "Public entities",
    "description": "Governance, reporting, procurement, and compliance material for public entities.",
    "count": 12,
    "accent": "blue"
  },
  {
    "id": "Supplier payment compliance",
    "name": "Supplier payment compliance",
    "description": "Reports and instructions on paying supplier invoices within 30 days.",
    "count": 24,
    "accent": "green"
  },
  {
    "id": "Supply chain management",
    "name": "Supply chain management",
    "description": "Procurement and supply-chain instructions for departments and entities.",
    "count": 7,
    "accent": "gold"
  },
  {
    "id": "Interest rates",
    "name": "Interest rates",
    "description": "Notices setting standard interest rates on debts owing to the State.",
    "count": 33,
    "accent": "red"
  },
  {
    "id": "Remunerative work",
    "name": "Remunerative work",
    "description": "Rates and guidance for commissions, committees, boards, and other remunerative work.",
    "count": 34,
    "accent": "blue"
  },
  {
    "id": "Training",
    "name": "Training",
    "description": "PFMA learning material, presentations, and public-finance training resources.",
    "count": 9,
    "accent": "green"
  }
];

export const documentPreviews: DocumentPreview[] = [
  {
    "id": "circular-02-of-2023-review-of-national-treasury-instructions-on-cost-containment-m__f5eed126bce4.pdf",
    "sourceDocumentId": "circular-02-of-2023-review-of-national-treasury-instructions-on-cost-containment-m__f5eed126bce4.pdf",
    "title": "Circular 02 of 2023 - Review of National Treasury Instructions on Cost Containment Measures",
    "collectionId": "Circulars",
    "collectionName": "Circulars",
    "type": "Circular",
    "year": 2023,
    "department": "National Treasury",
    "sourceUrl": "https://www.treasury.gov.za/legislation/pfma/circulars/Circular 02 of 2023 - Review of National Treasury Instructions on Cost Containment Measures_.pdf",
    "fileName": "Circular 02 of 2023 - Review of National Treasury Instructions on Cost Containment Measures___52aad47997.pdf",
    "pages": 0,
    "fileSize": "120 KB",
    "updatedAt": "Indexed",
    "relevance": 90,
    "matchStrength": "Strong match",
    "tags": [
      "cost containment",
      "Treasury Instructions",
      "review process",
      "survey",
      "PFMA"
    ],
    "excerpt": "This circular announces a review of National Treasury Instructions on cost containment measures and asks institutions and other stakeholders to participate in a survey by submitting inputs by 04 August 2023.",
    "sectionMatches": [
      "Circulars"
    ],
    "summary": "This circular announces a review of National Treasury Instructions on cost containment measures and asks institutions and other stakeholders to participate in a survey by submitting inputs by 04 August 2023.",
    "keyFacts": [
      "The circular is addressed to accounting officers of departments and constitutional institutions, accounting authorities of public entities listed in Schedules 2 and 3 to the PFMA, and head officials of provincial treasuries.",
      "Its purpose is to inform recipients about the review process underway in respect of Treasury Instructions issued on cost containment measures.",
      "It requests accounting officers, accounting authorities, and other officials within institutions to participate in a survey by providing responses and comments.",
      "The circular notes that cost containment measures were introduced in 2013 and that several treasury instructions remain effective.",
      "The due date for submission of inputs through the survey link is 04 August 2023."
    ],
    "excerpts": [
      {
        "heading": "Purpose",
        "page": 1,
        "text": "The purpose of this circular is to \u2013 1.1 inform accounting officers and accounting authorities of the review process that is underway in respect of Treasury Instructions issued on Cost Containment Measures; and 1.2 request accounting officers, accounting authorities, and any other official within the institution to participate in the survey process by providing responses and comments dealing with cost containment measures."
      },
      {
        "heading": "Background",
        "page": 1,
        "text": "In 2013, the National Treasury introduced cost containment measures to institutions (subject t o the PFMA). Subsequently , several treasury instructions on cost containment measures were issued, of which the following are still effective \u2013 (a) Treasury Instruction No. 03 of 2017/2018 on Cost Containment Measures intended to curtail and regulate certain goods and services items (b) Treasury Instruction No. 06 of 2019/2020 Procurement of vehicles for members of the Executives (c) Treasury Instruction No. 06 of 2022/2023 on the National Travel Framework (d) Treasury Instruction No. 07 of 2022/2023 on the Cost Containment Measures related to Travel & Subsistence"
      },
      {
        "heading": "Information to be submitted",
        "page": 2,
        "text": "The due date for submission of inputs through the below survey link is 04 August 2023: https://forms.office.com/r/NjzeSA6E7r"
      }
    ],
    "relatedDocuments": []
  },
  {
    "id": "amendment-to-government-notice-437-of-31-march-2020__008fc9b973d6.pdf",
    "sourceDocumentId": "amendment-to-government-notice-437-of-31-march-2020__008fc9b973d6.pdf",
    "title": "Amendment to Government Notice 437 of 31 March 2020",
    "collectionId": "Delays and exemptions",
    "collectionName": "Delays and exemptions",
    "type": "Exemption",
    "year": 2020,
    "department": "National Treasury",
    "sourceUrl": "https://www.treasury.gov.za/legislation/pfma/delayexemp/Amendment to Government Notice 437 of 31 March 2020.pdf",
    "fileName": "Amendment to Government Notice 437 of 31 March 2020__0080d4e6d4.pdf",
    "pages": 0,
    "fileSize": "124 KB",
    "updatedAt": "Indexed",
    "relevance": 90,
    "matchStrength": "Strong match",
    "tags": [
      "Public Finance Management Act",
      "Government Notice amendment",
      "Delays and exemptions",
      "National Treasury"
    ],
    "excerpt": "National Treasury notice amending Government Notice No. 437 of 31 March 2020 under the Public Finance Management Act, 1999. The amendment excludes certain institutions with a financial year ending 30 June, deletes the definition of \"national state of disaster,\" changes the compliance period in paragraph 2, and deletes subparagraph (3) of paragraph 2.",
    "sectionMatches": [
      "Delays and exemptions"
    ],
    "summary": "National Treasury notice amending Government Notice No. 437 of 31 March 2020 under the Public Finance Management Act, 1999. The amendment excludes certain institutions with a financial year ending 30 June, deletes the definition of \"national state of disaster,\" changes the compliance period in paragraph 2, and deletes subparagraph (3) of paragraph 2.",
    "keyFacts": [
      "Issued by Tito Titus Mboweni in terms of section 92 of the Public Finance Management Act, 1999 (Act No. 1 of 1999).",
      "Amends Government Notice No. 437 of 31 March 2020.",
      "Excludes an institution listed in a Schedule to that Act with a financial year ending 30 June, from the application of that Notice.",
      "Deletes the definition of \"national state of disaster\" in paragraph 1 of the Schedule.",
      "Substitutes subparagraph (2) of paragraph 2 of the Schedule to require compliance within two months after the deadline in the applicable provision."
    ],
    "excerpts": [
      {
        "heading": "Amendment notice",
        "page": 3,
        "text": "I, Tito Titus Mboweni, hereby in terms of section 92 of the Public Finance Management Act, 1999 (Act No. 1 of 1999), amend Government Notice No. 437 of 31 March 2020 by- (a)excluding an institution listed in a Schedule to that Act with a financial year ending 30 June, from the application of that Notice; (b)the deletion of the definition of \"national state of disaster\" in paragraph 1 of the Schedule; (c)the substitution of subparagraph (2) of paragraph 2 of the Schedule for the following subparagraph: \"(2) The relevant functionary or institution must comply with a provision referred to in subparagraph (1) within two months after the deadline in the applicable provision. \"; and (d)the deletion of subparagraph (3) of paragraph 2 of the Schedule."
      }
    ],
    "relatedDocuments": []
  },
  {
    "id": "delegation-principles-for-financial-management__50d459eec6bd.pdf",
    "sourceDocumentId": "delegation-principles-for-financial-management__50d459eec6bd.pdf",
    "title": "Delegation Principles for Financial Management",
    "collectionId": "Delegations",
    "collectionName": "Delegations",
    "type": "Delegation",
    "year": 0,
    "department": "National Treasury",
    "sourceUrl": "https://www.treasury.gov.za/legislation/pfma/delegations/Delegation Principles for Financial Management.pdf",
    "fileName": "Delegation Principles for Financial Management__773afc355a.pdf",
    "pages": 0,
    "fileSize": "858 KB",
    "updatedAt": "Indexed",
    "relevance": 90,
    "matchStrength": "Strong match",
    "tags": [
      "delegations",
      "public administration",
      "financial management",
      "PFMA",
      "PSA"
    ],
    "excerpt": "This document sets out principles to guide public administration and financial management delegations in terms of the PSA and PFMA, including legal framework, roles and responsibilities, delegation processes, templates, and implementation measures for standardising and improving delegation practice across the public service.",
    "sectionMatches": [
      "Delegations"
    ],
    "summary": "This document sets out principles to guide public administration and financial management delegations in terms of the PSA and PFMA, including legal framework, roles and responsibilities, delegation processes, templates, and implementation measures for standardising and improving delegation practice across the public service.",
    "keyFacts": [
      "Approved by Cabinet on 7 August 2013 (Cabinet Memorandum 56 of 2013).",
      "The document provides principles to guide the development of public administration and financial management delegations authorised and exercised in terms of the PSA and the PFMA.",
      "It includes chapters on definitions and concepts, legal framework, clarification of roles and responsibilities, delegation process and templates, delegation principles, and an implementation plan.",
      "Appendices include templates for public administration delegations, financial delegations under the PFMA and Treasury Regulations, a PAJA checklist, a delegation decisions register, and a VARICE tool.",
      "The glossary defines key terms such as Administrative action, Delegation, Principal Functionary, Delegated Official, Head of Department, and Power."
    ],
    "excerpts": [
      {
        "heading": "Background",
        "page": 7,
        "text": "This document provides principles to guide the development of public administration and financial management delegations authorised and exercised in terms of the PSA and the PFMA."
      }
    ],
    "relatedDocuments": []
  },
  {
    "id": "2024-public-entities-year-end-guidelines-with-water-boards__958779a419f9.pdf",
    "sourceDocumentId": "2024-public-entities-year-end-guidelines-with-water-boards__958779a419f9.pdf",
    "title": "2024 Public Entities Year-End guidelines with water boards",
    "collectionId": "Guidelines",
    "collectionName": "Guidelines",
    "type": "Guideline",
    "year": 2024,
    "department": "National Treasury",
    "sourceUrl": "https://www.treasury.gov.za/legislation/pfma/guidelines/2024 Public Entities Year-End guidelines with water boards.pdf",
    "fileName": "2024 Public Entities Year-End guidelines with water boards__e1200e6927.pdf",
    "pages": 0,
    "fileSize": "913 KB",
    "updatedAt": "Indexed",
    "relevance": 90,
    "matchStrength": "Strong match",
    "tags": [
      "PFMA",
      "Annual Financial Statements",
      "Annual Reports",
      "GRAP",
      "Public entities submission requirements"
    ],
    "excerpt": "Year-end guideline for national and provincial public entities on completing and submitting the 2024 AFS template, including inter-entity transactions, conversion journals, uncorrected misstatements, management remuneration, audit sign-off, timelines, and contact details.",
    "sectionMatches": [
      "Guidelines"
    ],
    "summary": "Year-end guideline for national and provincial public entities on completing and submitting the 2024 AFS template, including inter-entity transactions, conversion journals, uncorrected misstatements, management remuneration, audit sign-off, timelines, and contact details.",
    "keyFacts": [
      "Section 55 of the PFMA requires accounting officers for public entities to prepare and submit Annual Financial Statements (AFS) and Annual Reports (AR) to the National Treasury, the Auditor General of South Africa (AGSA) and their respective Executive Authority.",
      "The AFS template should be completed for the period commencing 1 April 2023 and ending 31 March 2024 (for entities with 31 March year-end) and for the period commencing 1 July 2023 and ending 30 June 2024 (for entities with 30 June year-end).",
      "The AFS template will be emailed to each entity separately and pre-populated with the public entities name and an entity specific code.",
      "All public entities listed in the PFMA Public Entity Listing issued by the National Treasury are required to complete the GRAP AFS template.",
      "Inter-entity transactions and balances within the group need to be eliminated on consolidation, and entities must complete the inter-entity worksheet for both current year 2023/24 amounts and prior year 2022/23 amounts (rounded off to the nearest R1 and not R1 000)."
    ],
    "excerpts": [
      {
        "heading": "Introduction",
        "page": 1,
        "text": "Section 55 of the Public Finance Management Act (PFMA) requires accounting officers for public entities to prepare and submit Annual Financial Statements (AFS) and Annual Reports (AR) to the National Treasury, the Auditor General of South Africa (AGSA) and their respective Executive Authority."
      },
      {
        "heading": "AFS Template",
        "page": 2,
        "text": "The AFS template that needs to be completed by public entities for the period ending 31 March 2024 or 30 June 2024 will be emailed to each entity separately and pre-populated with the public entities name and an entity specific code. No AFS template will be placed on the National Treasury website for download."
      },
      {
        "heading": "Inter-entity Transactions and Balances",
        "page": 2,
        "text": "In terms of GRAP 35.41, the framework for consolidated financial statements, all inter-entity transactions and balances within the group need to be eliminated on consolidation."
      }
    ],
    "relatedDocuments": []
  },
  {
    "id": "adjusted-standard-interest-rate-as-from-01-september-2019__907cb39b7dd5.pdf",
    "sourceDocumentId": "adjusted-standard-interest-rate-as-from-01-september-2019__907cb39b7dd5.pdf",
    "title": "Adjusted standard interest rate as from 01 September 2019",
    "collectionId": "Interest rates",
    "collectionName": "Interest rates",
    "type": "Notice",
    "year": 2019,
    "department": "National Treasury",
    "sourceUrl": "https://www.treasury.gov.za/legislation/pfma/interest rates/Adjusted standard interest rate as from 01 September 2019.pdf",
    "fileName": "Adjusted standard interest rate as from 01 September 2019__885e8e9b3d.pdf",
    "pages": 0,
    "fileSize": "128 KB",
    "updatedAt": "Indexed",
    "relevance": 90,
    "matchStrength": "Strong match",
    "tags": [
      "Interest rates",
      "PFMA section 80",
      "Government loans",
      "State Revenue Fund"
    ],
    "excerpt": "This circular minute announces a change to the standard interest rate on government loans/debt under section 80(1)(a) and (b) of the PFMA, stating that the rate decreases from 10.25% per annum to 10.00% per annum and is applicable until further notice.",
    "sectionMatches": [
      "Interest rates"
    ],
    "summary": "This circular minute announces a change to the standard interest rate on government loans/debt under section 80(1)(a) and (b) of the PFMA, stating that the rate decreases from 10.25% per annum to 10.00% per annum and is applicable until further notice.",
    "keyFacts": [
      "The document is from National Treasury.",
      "It concerns the standard interest rate on government loans/debt in terms of section 80 (1) (a) & (b) of the PFMA.",
      "The interest rate decreases from 10.25% per annum to 10,00% per annum.",
      "The decrease is stated to be published by notice in the Government Gazette of 01 September 2019.",
      "The circular says the decrease will be applicable from 01 September 2049 to drawings against loans/debts or portions thereof and will remain in force, until further notice."
    ],
    "excerpts": [
      {
        "heading": "Standard interest rate on government loans/debt",
        "page": 1,
        "text": "The Minister of Finance has in accordance with section 80 (1) (a) and (b) of the PFMA, published by notice in the Government Gazette of 01 September 2019, regarding the decrease in the interest rate from 10.25% per annum to 10,00% per annum on loans granted by the State out of the State Revenue Fund and/or to alll other debt which must be paid into the State Revenue Fund."
      },
      {
        "heading": "Applicability of the decrease",
        "page": 1,
        "text": "The decrease in the interest rate will be applicable from 01 September 2049 to drawings against loans/debts or portions thereof and will remain in force, until further notice."
      }
    ],
    "relatedDocuments": []
  },
  {
    "id": "act__3b2ee0dc2921.pdf",
    "sourceDocumentId": "act__3b2ee0dc2921.pdf",
    "title": "act",
    "collectionId": "PFMA legislation",
    "collectionName": "PFMA legislation",
    "type": "Legislation",
    "year": 0,
    "department": "National Treasury",
    "sourceUrl": "https://www.treasury.gov.za/legislation/pfma/act.pdf",
    "fileName": "act__85348c8b3b.pdf",
    "pages": 0,
    "fileSize": "426 KB",
    "updatedAt": "Indexed",
    "relevance": 90,
    "matchStrength": "Strong match",
    "tags": [
      "public finance management",
      "national treasury",
      "provincial treasuries",
      "revenue funds",
      "budgeting and appropriations"
    ],
    "excerpt": "The Public Finance Management Act 1 of 1999 regulates financial management in national and provincial government, with provisions on budgeting, treasury functions, revenue funds, accounting officers, public entities, borrowing, treasury regulations, financial misconduct, and accounting standards.",
    "sectionMatches": [
      "PFMA legislation"
    ],
    "summary": "The Public Finance Management Act 1 of 1999 regulates financial management in national and provincial government, with provisions on budgeting, treasury functions, revenue funds, accounting officers, public entities, borrowing, treasury regulations, financial misconduct, and accounting standards.",
    "keyFacts": [
      "The Act\u2019s object is \u201cto secure transparency, accountability, and sound management of the revenue, expenditure, assets and liabilities of the institutions to which this Act applies.\u201d",
      "It applies to departments, certain public entities, constitutional institutions, and provincial legislatures, subject to the Act.",
      "The National Treasury and provincial treasuries have defined powers over budgeting, cash management, reporting, and oversight.",
      "The Act sets rules for deposits into and withdrawals from the National Revenue Fund and Provincial Revenue Funds.",
      "Accounting officers and accounting authorities have responsibilities for internal control, reporting, and preventing irregular, unauthorised, and fruitless and wasteful expenditure."
    ],
    "excerpts": [
      {
        "heading": "Long title",
        "page": 1,
        "text": "To regulate financial management in the national government and provincial governments; to ensure that all revenue, expenditure, assets and liabilities of those governments are managed efficiently and effectively; to provide for the responsibilities of persons entrusted with financial management in those governments; and to provide for matters connected therewith."
      },
      {
        "heading": "Object of this Act",
        "page": 12,
        "text": "The object of this Act is to secure transparency, accountability, and sound management of the revenue, expenditure, assets and liabilities of the institutions to which this Act applies."
      },
      {
        "heading": "Institutions to which this Act applies",
        "page": 12,
        "text": "This Act, to the extent indicated in the Act, applies to\u2014 (a) departments; (b) public entities listed in Schedule 2 or 3; (c) constitutional institutions; and (d) the provincial legislatures, subject to subsection (2) ."
      }
    ],
    "relatedDocuments": []
  },
  {
    "id": "accountant-general-practice-note-1-of-2001-treasury-regulation-15-2-3-warrant-vouc__a22943f17c0e.pdf",
    "sourceDocumentId": "accountant-general-practice-note-1-of-2001-treasury-regulation-15-2-3-warrant-vouc__a22943f17c0e.pdf",
    "title": "Accountant-General Practice Note 1 of 2001 - Treasury Regulation 15.2.3: warrant vouchers in excess of R10 000",
    "collectionId": "Practice notes",
    "collectionName": "Practice notes",
    "type": "Practice note",
    "year": 2001,
    "department": "National Treasury",
    "sourceUrl": "https://www.treasury.gov.za/legislation/pfma/practice notes/oag/2001-01 Practice  Note.pdf",
    "fileName": "2001-01 Practice Note__773a4e841c.pdf",
    "pages": 0,
    "fileSize": "41 KB",
    "updatedAt": "Indexed",
    "relevance": 90,
    "matchStrength": "Strong match",
    "tags": [
      "Treasury Regulation 15.12.3",
      "warrant vouchers",
      "payments over R10 000.00",
      "Paymaster General approval",
      "telegraphic transfers"
    ],
    "excerpt": "Practice note from the Office of the Accountant General stating that Treasury Regulation 15.12.3 applies to warrant vouchers in excess of R10 000.00, and that such vouchers will be returned unpaid unless prior approval is obtained from the Paymaster General in exceptional circumstances.",
    "sectionMatches": [
      "Practice notes"
    ],
    "summary": "Practice note from the Office of the Accountant General stating that Treasury Regulation 15.12.3 applies to warrant vouchers in excess of R10 000.00, and that such vouchers will be returned unpaid unless prior approval is obtained from the Paymaster General in exceptional circumstances.",
    "keyFacts": [
      "Date: 15 January 2001.",
      "Issued to: all Accounting Officers and Chief Financial Officers.",
      "Treasury Regulation 15.12.3 is described as explicit regarding the method of payment for amounts exceeding R 10 000.00.",
      "Any warrant voucher issued in excess of R10 000.00 will be returned as unpaid by the Paymaster General with immediate effect.",
      "Prior approval from the Paymaster General is required in exceptional circumstances for payment in excess of R10 000.00 by warrant voucher."
    ],
    "excerpts": [
      {
        "heading": "Compliance with warrant voucher limit",
        "page": 1,
        "text": "any warrant voucher issued in excess of R10 000.00 will with immediate effect be retumed as unpaid by the Paymaster General."
      },
      {
        "heading": "Information required for exceptional approval",
        "page": 1,
        "text": "The following information must be supplied by the Chief Financial Officer before the request can be considered for approval: 1. Payee's name; 2. amount; 3. number of warrant voucher; 4, date of warrant voucher; 5. __ reason why the payment can not be effected electronically; and 6. _ signature of Chief Financial Officer (No delegations will be accepted)."
      },
      {
        "heading": "Urgent telegraphic transfers",
        "page": 2,
        "text": "Please be advised that arrangements have been made for urgent telegraphic transfers only with the South African Reserve Bank. Telegraphic transfer instructions received by the South African Reserve Bank.before 11h00 will be effected the same day."
      }
    ],
    "relatedDocuments": []
  },
  {
    "id": "circular-on-contracts-containing-provisions-relating-to-indemnities-limitation-of__f817e6ce3bb7.pdf",
    "sourceDocumentId": "circular-on-contracts-containing-provisions-relating-to-indemnities-limitation-of__f817e6ce3bb7.pdf",
    "title": "Circular on contracts containing provisions relating to indemnities, limitation of liabilities and warranties",
    "collectionId": "Public entities",
    "collectionName": "Public entities",
    "type": "Guideline",
    "year": 0,
    "department": "National Treasury",
    "sourceUrl": "https://www.treasury.gov.za/legislation/pfma/public entities/Departments.pdf",
    "fileName": "Departments__84df10a8b8.pdf",
    "pages": 0,
    "fileSize": "899 KB",
    "updatedAt": "Indexed",
    "relevance": 90,
    "matchStrength": "Strong match",
    "tags": [
      "PFMA",
      "indemnities",
      "limitation of liability",
      "warranties",
      "Minister of Finance concurrence"
    ],
    "excerpt": "National Treasury circular on contracts containing indemnities, limitation of liabilities and warranties. It explains when the Minister of Finance\u2019s written concurrence is and is not required under sections 66 and 70 of the PFMA, focusing on operational contracts and budgeted expenditure.",
    "sectionMatches": [
      "Public entities"
    ],
    "summary": "National Treasury circular on contracts containing indemnities, limitation of liabilities and warranties. It explains when the Minister of Finance\u2019s written concurrence is and is not required under sections 66 and 70 of the PFMA, focusing on operational contracts and budgeted expenditure.",
    "keyFacts": [
      "The circular is addressed to accounting officers of all national departments and constitutional institutions, and accounting authorities of all public entities.",
      "It says the Minister of Finance is frequently requested to provide concurrence for transactions with indemnity, limitation of liability and warranty clauses.",
      "It states that, on a strict interpretation of sections 66 and 70 of the PFMA, concurrence would be required before concluding any contract containing such clauses.",
      "National Treasury\u2019s view is that concurrence is not required where the clause is integral or incidental to approved expenditure and is necessitated by day-to-day operational requirements.",
      "The circular says written concurrence is required for indemnity, limitation of liability or warranty related to transactions for which funds have not been provided on the budget."
    ],
    "excerpts": [
      {
        "heading": "Address and subject",
        "page": 1,
        "text": "ACCOUNTING OFFICERS OF ALL NATIONAL DEPARTMENTS AND CONSTITUTIONAL INSTITUTIONS ACCOUNTING AUTHORITIES OF ALL PUBLIC ENTITIES CONTRACTS CONTAINING PROVISIONS RELATING LIMITATION OF LIABILITIESAND WARRANTIES 1. 2. 3. 4. TO INDEMNITIES,"
      },
      {
        "heading": "National Treasury view on when concurrence is not required",
        "page": 2,
        "text": "Takingcognisanceoftheaforegoing,theviewoftheNationalTreasuryisthat theMinister'sconcurrencewould notbe requiredwhere: 5.1 The indemnity,limitationofliabilityorwarrantyisintegralor incidental to expenditurethat has already been approved by the relevant legislatureor executiveauthorityin the annual budget of the department/constitutionalinstitutionorpublicentityrespectively;and"
      }
    ],
    "relatedDocuments": []
  },
  {
    "id": "amendment-to-treasury-regulations-on-limitation-of-credit-debit-cards__6c6ebc68b934.pdf",
    "sourceDocumentId": "amendment-to-treasury-regulations-on-limitation-of-credit-debit-cards__6c6ebc68b934.pdf",
    "title": "Amendment to Treasury Regulations on limitation of credit & debit cards",
    "collectionId": "Regulations",
    "collectionName": "Regulations",
    "type": "Regulation",
    "year": 0,
    "department": "National Treasury",
    "sourceUrl": "https://www.treasury.gov.za/legislation/pfma/regulations/37042_15-11_NationalTreasuryCV01.pdf",
    "fileName": "37042_15-11_NationalTreasuryCV01__93bee5f693.pdf",
    "pages": 0,
    "fileSize": "316 KB",
    "updatedAt": "Indexed",
    "relevance": 90,
    "matchStrength": "Strong match",
    "tags": [
      "Public Finance Management Act",
      "Treasury Regulations",
      "credit cards",
      "debit cards",
      "National Treasury"
    ],
    "excerpt": "This Government Notice amends the Treasury Regulations under the Public Finance Management Act, 1999. It deletes certain regulations and adds new provisions limiting the obtaining and retention of credit and debit cards by departments, constitutional institutions, and certain public entities, with specified exceptions and exemption powers for the National Treasury.",
    "sectionMatches": [
      "Regulations"
    ],
    "summary": "This Government Notice amends the Treasury Regulations under the Public Finance Management Act, 1999. It deletes certain regulations and adds new provisions limiting the obtaining and retention of credit and debit cards by departments, constitutional institutions, and certain public entities, with specified exceptions and exemption powers for the National Treasury.",
    "keyFacts": [
      "In terms of section 78 of the Public Finance Management Act, 1999 (Act No. 1 of 1999), the Minister of Finance amends the Treasury Regulations.",
      "The notice is Government Notice R. 874, dated 15 November 2013.",
      "The Schedule deletes regulation 13.1.5 and regulation 32.1.2.",
      "New provisions are added to regulation 15.10.3 and regulation 31.2 concerning credit and debit cards.",
      "The amendments allow limited retention or obtaining of certain cards for travel agencies, one institutional card with approval authority by one office-bearer or official, and fleet management, petrol and garage cards when specified conditions apply."
    ],
    "excerpts": [
      {
        "heading": "Amendment authority",
        "page": 3,
        "text": "In terms of section 78 of the Public Finance Management Act, 1999 (Act No. 1 of 1999),I,Pravin J Gordhan, the Minister of Finance hereby amend the Treasury Regulations (published under Government Notice R225 of 15 March 2005, as amended), as set out in the Schedule."
      },
      {
        "heading": "Restriction on department or constitutional institution cards",
        "page": 4,
        "text": "15.10.3.3Witheffectfrom15 November 2013,no departmentor constitutional institution may, subject to regulation 15.10.3.5, obtain a credit or debit card, whether inthe name of the institution or any office-bearer or official of the department or constitutional institution."
      },
      {
        "heading": "Restriction on public entity cards",
        "page": 5,
        "text": "31.2.5With effect from 15 November 2013, no public entity listed in Schedule 2 or 3 to the Act, may, subject to regulation 31.2.7, obtain a credit or debit card, whether in the name of the public entity or any office-bearer or official of the institution."
      }
    ],
    "relatedDocuments": []
  },
  {
    "id": "2004-rates-i-t-o-tr-20-2-2__2f534370409d.pdf",
    "sourceDocumentId": "2004-rates-i-t-o-tr-20-2-2__2f534370409d.pdf",
    "title": "2004 Rates i.t.o. TR 20.2.2",
    "collectionId": "Remunerative work",
    "collectionName": "Remunerative work",
    "type": "Circular",
    "year": 2004,
    "department": "National Treasury",
    "sourceUrl": "https://www.treasury.gov.za/legislation/pfma/renumerative/Remuneration tariffs of non official members .pdf",
    "fileName": "Remuneration tariffs of non official members__d096a9a1b7.pdf",
    "pages": 0,
    "fileSize": "66 KB",
    "updatedAt": "Indexed",
    "relevance": 90,
    "matchStrength": "Strong match",
    "tags": [
      "Remunerative work",
      "Treasury Regulation 20.2.2",
      "Commissions and committees of inquiry",
      "Remuneration tariffs",
      "Non-official members"
    ],
    "excerpt": "National Treasury communicated approved maximum remuneration tariffs for non-official members of commissions and committees of inquiry under Treasury Regulation 20.2.2, effective from 1 April 2004. It also states that employees of government and government agencies/entities are not entitled to additional remuneration and that any resulting expenditure must be financed within departments\u2019 medium term expenditure framework.",
    "sectionMatches": [
      "Remunerative work"
    ],
    "summary": "National Treasury communicated approved maximum remuneration tariffs for non-official members of commissions and committees of inquiry under Treasury Regulation 20.2.2, effective from 1 April 2004. It also states that employees of government and government agencies/entities are not entitled to additional remuneration and that any resulting expenditure must be financed within departments\u2019 medium term expenditure framework.",
    "keyFacts": [
      "Addressed to all national and provincial accounting officers and heads of provincial treasuries.",
      "Concerned with \"Treasury Regulations: Commissions and Committees of Inquiry: Remuneration Tariffs of Non-Official Members\".",
      "States that, in terms of Treasury Regulation 20.2.2, maximum remuneration tariffs were approved by the National Treasury.",
      "Provides tariffs for Chairperson and Member roles for Commission and Committee.",
      "States: \"Employees of National, Provincial and Local Government or Agencies and Entities of Government are not entitled to additional remuneration.\"\",\"The tariffs take effect from 1 April 2004.\",\"States that expenditure incurred as a result of the adjustment must be financed from within Departments\u2019 medium term expenditure framework.\""
    ],
    "excerpts": [
      {
        "heading": "Treasury Regulation 20.2.2 tariffs",
        "page": 1,
        "text": "In terms of Treasury Regulation 20.2.2 the following maximum remuneration tariffs regarding the payment of members of the above-mentioned commissionsicommittees were approved by the National Treasury. Employees of National, Provincial and Local Government or Agencies and Entities of Government are not entitled to additional remuneration. COMMISSION COMMITTEE Chairperson R2 414 pd. R1 989 p.d. Member R1 793 p.d. R1 203 p.d"
      },
      {
        "heading": "Effective date",
        "page": 1,
        "text": "The above remuneration tariffs take effect from 1 April 2004."
      },
      {
        "heading": "Funding instruction",
        "page": 1,
        "text": "Expenditure incurred as a result of the adjustment must be financed from within Departments\u2019 medium term expenditure framework"
      }
    ],
    "relatedDocuments": []
  },
  {
    "id": "annual-report-2019-20__316064c6a37a.pdf",
    "sourceDocumentId": "annual-report-2019-20__316064c6a37a.pdf",
    "title": "Annual Report 2019-20",
    "collectionId": "Supplier payment compliance",
    "collectionName": "Supplier payment compliance",
    "type": "Report",
    "year": 2019,
    "department": "National Treasury",
    "sourceUrl": "https://www.treasury.gov.za/legislation/pfma/Compliance on Payment of Suppliers/Annual Report - 30 days Payments - 2019-20.pdf",
    "fileName": "Annual Report - 30 days Payments - 2019-20__c7db3bfeed.pdf",
    "pages": 0,
    "fileSize": "2719 KB",
    "updatedAt": "Indexed",
    "relevance": 90,
    "matchStrength": "Strong match",
    "tags": [
      "PFMA compliance",
      "supplier payment within 30 days",
      "exception reports",
      "national departments",
      "provincial departments"
    ],
    "excerpt": "The report monitors compliance with PFMA and Treasury Regulation requirements for paying supplier invoices within 30 days during the 2019/2020 financial year, comparing national and provincial departments with the 2018/2019 financial year. It summarizes reporting timeliness, numbers and values of invoices paid late or still unpaid, common reasons for non-payment, COVID-19-related extensions, and interventions intended to improve compliance.",
    "sectionMatches": [
      "Supplier payment compliance"
    ],
    "summary": "The report monitors compliance with PFMA and Treasury Regulation requirements for paying supplier invoices within 30 days during the 2019/2020 financial year, comparing national and provincial departments with the 2018/2019 financial year. It summarizes reporting timeliness, numbers and values of invoices paid late or still unpaid, common reasons for non-payment, COVID-19-related extensions, and interventions intended to improve compliance.",
    "keyFacts": [
      "Section 38(1)(f) of the PFMA states that the accounting officer for a department must settle all contractual obligations and pay all money owing, including intergovernmental claims, within the prescribed or agreed period.",
      "Treasury Regulation 8.2.3 states that all payments due to creditors must be settled within 30 days from receipt of an invoice, unless determined otherwise in a contract or other agreement.",
      "National departments achieved an annual average timeous submission rate of 85% during 2019/2020 financial year.",
      "Provincial treasuries achieved an annual average timeous submission rate of 65% in 2019/2020 financial year.",
      "National departments recorded 143 071 invoices paid after 30 days in 2019/2020 financial year, with a total rand value of R 6.7 billion reported in the text for that period for this analysis section contextually tied to late payments by national departments; provincial departments recorded 278 232 invoices paid after 30 days, with a total rand value of R 27."
    ],
    "excerpts": [
      {
        "heading": "Extracted source text",
        "page": 2,
        "text": "ANNUAL REPORT ON PAYMENTS OF INVOICES WITHIN 30 DAYS \u2013 2019/2020 FINANCIAL YEAR Page 1 of 34 TABLE OF CONTENTS 1."
      }
    ],
    "relatedDocuments": []
  },
  {
    "id": "amendment-to-the-state-tender-board-act-regulations-to-empower-accounting-officers__ceb35aa97aae.pdf",
    "sourceDocumentId": "amendment-to-the-state-tender-board-act-regulations-to-empower-accounting-officers__ceb35aa97aae.pdf",
    "title": "Amendment to the State Tender Board Act Regulations to Empower Accounting Officers to arrange their own Ad Hoc tenders",
    "collectionId": "Supply chain management",
    "collectionName": "Supply chain management",
    "type": "Treasury instruction",
    "year": 0,
    "department": "National Treasury",
    "sourceUrl": "https://www.treasury.gov.za/legislation/pfma/supplychain/Amendment to the State Tender Board Act Regulations.pdf",
    "fileName": "Amendment to the State Tender Board Act Regulations__441f519cc3.pdf",
    "pages": 0,
    "fileSize": "134 KB",
    "updatedAt": "Indexed",
    "relevance": 90,
    "matchStrength": "Strong match",
    "tags": [
      "supply chain management",
      "tender regulation",
      "State Tender Board",
      "procurement",
      "public finance management"
    ],
    "excerpt": "This December 2003 National Treasury notice amends the State Tender Board Regulations under the State Tender Board Act, 1968. It sets out definitions, the Board\u2019s powers and procedures, committee and regional tender board application, decision-making rules, preference, and withdrawal of the earlier 1988 regulations.",
    "sectionMatches": [
      "Supply chain management"
    ],
    "summary": "This December 2003 National Treasury notice amends the State Tender Board Regulations under the State Tender Board Act, 1968. It sets out definitions, the Board\u2019s powers and procedures, committee and regional tender board application, decision-making rules, preference, and withdrawal of the earlier 1988 regulations.",
    "keyFacts": [
      "The Minister of Finance amended Regulation 2 of the State Tender Board Regulations in terms of section 13 of the State Tender Board Act, 1968.",
      "The notice states that it supersedes Government Notice R. 1237 as published in Government Gazette 11382 of 1 July 1988.",
      "Regulation 2 states that supplies and services, hiring or letting, acquisition or granting of rights, and disposal of movable State property shall be procured, arranged or disposed of through the Board, or in terms of the Public Finance Management Act, No. 1 of 1999 (as amended by Act 29 of 1999).",
      "The Board may issue directives to Government departments regarding procurement, may invite expert or technical advice, and may approve ex post facto actions in certain circumstances.",
      "The Board may impose, vary, or rescind restrictions on persons in specified circumstances, and may recover costs, damages, or impose a penalty not exceeding 5 per cent of the monetary value of an agreement in cases of incorrect information after conclusion of an agreement."
    ],
    "excerpts": [
      {
        "heading": "Amendment notice",
        "page": 1,
        "text": "The Minister of Finance has, in terms of Section 13 of the State Tender Board Act, 1968 (Act No. 86 of 1968), amended Regulation 2 of the State Tender Board Regulations that w ere published in Government Gazette No. 11382 dated 1 July 1988 as set out in the Schedule."
      },
      {
        "heading": "Procurement through the Board",
        "page": 2,
        "text": "Subject to the provisions of any Act of Parliament supplies and services for and on behalf of the State, the hiring or letting of anything or the acquisition or granting of any right for and on behalf of the state and the disposal of movable State property shall be procured, arranged or disposed of through the Board, or in terms of the Public Finance Management Act, No. 1 of 1999 (as amended by Act 29 of 1999)."
      },
      {
        "heading": "Board powers",
        "page": 2,
        "text": "The Board may, subject to the applicable provisions of any Act of Parliament, issue directives to Government departments in regard to the procurement of supplies and services, the hiring or letting of anything, or the acquisitioning or granting of any right, and the disposal of movable Government property in order to achieve the objects of the Act."
      }
    ],
    "relatedDocuments": []
  },
  {
    "id": "appendix-a-the-institute-for-public-finance-and-auditing-qualifications__e254ee10cb5b.pdf",
    "sourceDocumentId": "appendix-a-the-institute-for-public-finance-and-auditing-qualifications__e254ee10cb5b.pdf",
    "title": "Appendix A: The Institute for Public Finance and Auditing Qualifications",
    "collectionId": "Training",
    "collectionName": "Training",
    "type": "Training material",
    "year": 0,
    "department": "National Treasury",
    "sourceUrl": "https://www.treasury.gov.za/legislation/pfma/training/Appendix A.pdf",
    "fileName": "Appendix A__029babef33.pdf",
    "pages": 0,
    "fileSize": "46 KB",
    "updatedAt": "Indexed",
    "relevance": 90,
    "matchStrength": "Strong match",
    "tags": [
      "Training framework",
      "IPFA qualifications",
      "SAQA framework",
      "assessment criteria",
      "accreditation"
    ],
    "excerpt": "The appendix sets out four Institute for Public Finance and Auditing (IPFA) qualifications on the SAQA framework and provides common assessment, accreditation, embedded knowledge, and benchmarking information. It then lists the National Masters Degree, National Degree, National Diploma, and National Certificate in Public Sector Accounting, including their NQF levels, credits, purposes, learning assumed to be in place, exit level outcomes, standards, electives, and rules of combination.",
    "sectionMatches": [
      "Training"
    ],
    "summary": "The appendix sets out four Institute for Public Finance and Auditing (IPFA) qualifications on the SAQA framework and provides common assessment, accreditation, embedded knowledge, and benchmarking information. It then lists the National Masters Degree, National Degree, National Diploma, and National Certificate in Public Sector Accounting, including their NQF levels, credits, purposes, learning assumed to be in place, exit level outcomes, standards, electives, and rules of combination.",
    "keyFacts": [
      "IPFA has recorded four qualifications on the SAQA framework: National Masters Degree in Public Sector Financial Management, National Degree in Public Sector Accounting, National Diploma in Public Sector Accounting, and National Certificate in Public Sector Accounting.",
      "Common material in the appendix covers performance levels, critical cross-field outcomes, assessment criteria, requirements for a portfolio, accreditation, embedded knowledge, and benchmarking.",
      "The National Masters Degree in Public Sector Financial Management is Tier 1, NQF Level 08, with 535 credits.",
      "The National Degree in Public Sector Accounting is Tier 2, NQF Level 07, with 376 credits.",
      "The National Diploma in Public Sector Accounting is Tier 3, NQF Level 06, with 322 credits, and the National Certificate in Public Sector Accounting is Tier 4, NQF Level 05, with 179 credits."
    ],
    "excerpts": [
      {
        "heading": "Appendix A qualifications",
        "page": 1,
        "text": "IPFA has recorded the following four qualifications on the SAQA framework:-"
      },
      {
        "heading": "Assessment criteria",
        "page": 2,
        "text": "Integrated assessment methods and tools will allow the candidate to demonstrate that she/ he has acquired knowledge of and can safely and effectively apply competence in public finance; administration procedures; clear and effective communication skills; resource selection and business principles."
      },
      {
        "heading": "National Masters Degree in Public Sector Financial Management",
        "page": 5,
        "text": "NQF LEVEL 08 CREDITS 535"
      }
    ],
    "relatedDocuments": []
  }
];

export const filterOptions: FilterOptions = {
  "documentTypes": [
    "Circular",
    "Delegation",
    "Exemption",
    "Guideline",
    "Legislation",
    "Notice",
    "Practice note",
    "Regulation",
    "Report",
    "Template",
    "Training material",
    "Treasury instruction"
  ],
  "years": [
    2026,
    2025,
    2024,
    2023,
    2022,
    2021,
    2020,
    2019,
    2018,
    2017,
    2016,
    2015,
    2014,
    2013,
    2012,
    2011,
    2010,
    2009,
    2008,
    2007,
    2006,
    2005,
    2004,
    2003,
    2002,
    2001,
    2000,
    1999
  ],
  "tags": [
    "2001/02 financial year",
    "2007",
    "30 days exception reports",
    "30-day exception reports",
    "30-day invoice payment",
    "30-day invoice payments",
    "30-day invoice rule",
    "30-day payment period",
    "30-day payment requirement",
    "30-day payment rule",
    "30-day payments",
    "accommodation",
    "Accommodation expenses",
    "accountability",
    "Accountability",
    "accountant-general",
    "Accountant-General",
    "Accountant-General practice note",
    "accounting authorities",
    "accounting authority",
    "accounting officer",
    "Accounting Officer certification",
    "Accounting officer certification",
    "Accounting officer responsibilities",
    "Accounting officers",
    "accounting officers",
    "accounting procedures",
    "Accounting procedures",
    "Accounting skills",
    "accreditation",
    "Activity-based approach",
    "agencification",
    "Agency and outsourced services",
    "Annexure A",
    "Annexure A certificate of compliance",
    "Annexure A rates",
    "Annexure B financial indicators",
    "Annual financial statements",
    "annual financial statements",
    "Annual Financial Statements",
    "Annual financial statements submission.",
    "Annual performance plan",
    "annual reporting",
    "Annual Reports",
    "annual reports",
    "Annual Statements",
    "Anti-corruption measures",
    "Application",
    "Application and commencement",
    "appropriation",
    "April 2025",
    "assessment criteria",
    "Assessment tools",
    "Audit and internal control",
    "Audit committee",
    "audit committees",
    "Audit Committees",
    "Audit committees",
    "Audit outcomes implementation plans",
    "Audited financial statements",
    "Auditor General monitoring",
    "Auditor-General",
    "auditor-general certification",
    "authorisation",
    "Automatic closure",
    "B-BBEE",
    "bank account details",
    "Bank account details",
    "Bank accounts",
    "bank charges",
    "Bank Credit Transfer controls",
    "bank reconciliation",
    "Bank reconciliation",
    "Bank reconciliations",
    "bank reconciliations",
    "banking details",
    "BAS",
    "BAS and PERSAL interface",
    "BAS implementation",
    "BAS technical environment"
  ]
};
